import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { blankGoal } from "@/lib/auditGoals";

export function AuditGoalEditor({ category, goals, onChange }) {
  const upd = (i, patch) => onChange(goals.map((g, j) => (j === i ? { ...g, ...patch } : g)));
  return (
    <div className="space-y-2" data-testid={`audit-goals-${category}`}>
      {goals.map((g, i) => g.category === category && (
        <div key={g.id || i} className="border border-slate-200 p-2 space-y-2" data-testid={`audit-goal-${category}-${i}`}>
          <div className="flex gap-2">
            <input value={g.label} onChange={(e) => upd(i, { label: e.target.value })} placeholder="Bezeichnung, z. B. Bekanntheitsgrad steigern" className="input-tech flex-1" data-testid={`audit-goal-label-${category}-${i}`} />
            <button type="button" onClick={() => onChange(goals.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600" data-testid={`audit-goal-del-${category}-${i}`}><Trash2 size={14} /></button>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            <select value={g.direction} onChange={(e) => upd(i, { direction: e.target.value })} className="input-tech" data-testid={`audit-goal-direction-${category}-${i}`}>
              <option value="min">mindestens</option><option value="max">höchstens</option>
            </select>
            <input type="number" step="any" value={g.target ?? ""} onChange={(e) => upd(i, { target: e.target.value })} placeholder="Zielwert" className="input-tech text-right" data-testid={`audit-goal-target-${category}-${i}`} />
            <input type="number" step="any" value={g.actual ?? ""} onChange={(e) => upd(i, { actual: e.target.value })} placeholder="Ist-Wert" className="input-tech text-right" data-testid={`audit-goal-actual-${category}-${i}`} />
            <select value={g.unit} onChange={(e) => upd(i, { unit: e.target.value })} className="input-tech" data-testid={`audit-goal-unit-${category}-${i}`}>
              <option value="%">%</option><option value="Anzahl">Anzahl</option>
            </select>
          </div>
          <input value={g.note} onChange={(e) => upd(i, { note: e.target.value })} placeholder="Quelle / Bemerkung" className="input-tech" data-testid={`audit-goal-note-${category}-${i}`} />
        </div>
      ))}
      <button type="button" onClick={() => onChange([...goals, blankGoal(category)])} className="text-xs text-slate-600 hover:text-slate-900 flex items-center gap-1" data-testid={`audit-goal-add-${category}`}><Plus size={12} /> Ziel hinzufügen</button>
    </div>
  );
}
